<template>
    <div class="posts__section" :class="columnClass">

        <div v-for="(story, index) in stories"
             :key="index"
             class="post__content" v-bind:class="{'float-right': (index % 2 !== 0)}">

                <div class="home__posts-thumbnail">
                    <div class="home__posts-edition" v-if="story.edition_label">
                        {{ story.edition_label }}
                    </div>
                    <a :href="story.url">
                        <img :src="'https://amsterdamlightfestival.com/storage/' +  story.thumbnail_image ">
                        <span class="story-date" v-if="! inDepth">{{ story.date }}</span>
                    </a>
                </div>

                <div class="home__posts-content">
                    <span class="story-column" v-if="inDepth">{{ story.column }}</span>
                    <span class="story-date" v-else-if="!inDepth">{{ story.date }}</span>
                    <span class="story-date-column-empty" v-else></span>
                    <h3>
                        {{ story.title }}
                    </h3>

                    <p v-if="story.excerpt" v-html="story.excerpt"></p>
                    <p v-else v-html="story.intro"></p>

                    <div class="post__content-action">
                        <a :href="story.url" class="post__content-btn">
                            {{ readMoreLabel }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.3" ><path d="M14 7.2L6.9 0l-.6.6 6 6.1H0v.9h12.3l-6 6.1.6.6z"/></svg>
                        </a>
                    </div><!-- /.action-section -->
                </div><!-- /.post__content-inner2 -->

        </div><!-- /.post__content -->

        <h2 v-show="hasNoStories" v-text="noStoriesFound"></h2>

    </div>
</template>
<script>
    import Loader from '.././loader'
    import helpers from '../../helpers';

    export default{
        props: {
            'columnClass': {required: true},
            'stories': {required: true},
            'inDepth': {required: true}
        },
        components: {
            'alf-loader': Loader
        },
        data: function(){
            return {
                // columnClassSync: this.columnClass,
            }
        },
        computed: {
            columnClassSync: function(){
                return this.columnClass
            },
            readMoreLabel: function () {
                if (helpers.getLocale() === 'nl') {
                    return 'LEES MEER';
                }
                return 'READ MORE';
            },
            hasNoStories: function(){
                return this.stories.length < 1;
            },
            noStoriesFound: function(){
                if(helpers.getLocale() === 'nl') {
                    return 'Deze categorie bevat geen verhalen ';
                }
                return 'This category contains no stories';

            }
        }
    }

</script>
<style lang="scss" scoped>

    .posts__section{
        margin-top: 25px;
    }

    h2{
        font-size: 18px;
    }

    .post__content {
        display: inline-block;
        position: relative;
        width: 33.3%;
        max-width: 570px;
        /*float: left;*/
        /*padding-left: 30px;*/
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 0;
    }

    .home__posts-thumbnail a img{
        max-width: 570px;
        max-height: 358px;
    }



    .post__content .post__content-inner2{
        height: 155px;

    }

    .home__posts-content{
        min-height:265px;
    }

    .home__posts-content p{
        min-height: 104px;
        line-height: 28px;
    }

    .story-column {
        font-size:19px;
        height:30px;

        display: block;
    }

    .story-date-column-empty {
        height:30px;
        display:block;
    }

    @media screen and (min-width: 1025px) and (max-width: 1100px){
        .home__posts-thumbnail a img{
            max-height: 293px;
        }
    }

    @media screen and (min-width: 1100px) and (max-width: 1200px){
        .home__posts-thumbnail a img{
            max-height: 322px;
        }
    }


    @media screen and (max-width: 1202px){
        .post__content {
            width: 48%;
            /*padding: 0 15px;*/
        }
    }
    @media screen and (max-width: 663px){
        .post__content {
            width: 100%;
        }
    }

    .float-right{
        float: right;
    }

    .one-column{
        .home__posts-thumbnail{
            a .story-date{
                display: none;
            }
        }
        .post__content{
            display: grid;
            grid-template-columns: 1fr 1.3fr;
            width: 100%;
            max-width: 100%;

            .home__posts-thumbnail{
                max-width: 375px;
                a img{
                    max-height: 227px;
                }

            }
            .home__posts-content{
                max-width: 525px;
                padding: 27px 25px;
            }
            //.post__content-btn {
            //    padding: 0 23px 0 7px;
            //    background-size: 12px auto;
            //    background-position: right 7px center;
            //    letter-spacing: .03em;
            //    font-size: 14px;
            //    line-height: 23px;
            //}
        }

        @media screen and (max-width: 550px) {
            .post__content{
                display: block;
                .home__posts-thumbnail{
                    width: 100%;
                }
                .home__posts-content{
                    max-width: 100%;
                    padding: 18px 0;
                }
            }

        }
    }


    .two-columns{
        .home__posts-thumbnail{
            a .story-date{
                display: none;
            }
        }
        .post__content{
            margin-bottom: 30px;
            width: 50%;
            @media screen and (max-width: 800px) {
                width: 100%;
            }
        }

    }
    .three-columns{
        .home__posts-thumbnail{
            position: relative;
            a .story-date{
                color: #fff;
                padding: 5px;
                font-size: 12px;
                position: absolute;
                left: 0;
                bottom: 0;
                background-color: #000;
                opacity: .8;
            }
        }
        .home__posts-content{
            min-height: 0;
            p{
                display: none;
            }
            .story-date {
                display: none;
            }
            h3{
                font-size: 22px;
                line-height: 26px;
                margin: 0 0 5px;
                letter-spacing: 0.01em;
                margin-bottom: 15px;
            }
        }
        .post__content{
            margin-bottom: 40px;
            width: 33.3%;
            @media screen and (max-width: 800px) {
                width: 50%;
            }
            @media screen and (max-width: 550px) {
                width: 100%;
            }
            //.post__content-btn{
            //    padding: 0 23px 0 7px;
            //    background-size: 12px auto;
            //    background-position: right 7px center;
            //    letter-spacing: .03em;
            //    font-size: 14px;
            //    line-height: 23px;
            //};
        }


    }

    //.post__content-btn svg{
    //    right: 7px;
    //    top: 6px;
    //}

</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/stories/stories-items.vue